import React from 'react';
import Accounts from '../assets/Accounts.svg';
import Apps from '../assets/Apps.svg';
import RightArrow from '../assets/Right_arrow.svg';
import text from '.';

const entityImages = {
	accounts: Accounts,
	apps: Apps,
};
const Entity = (props) => {
	const imgSrc = entityImages[props.entityKey];
	return (
		<div
			className="d-flex flex-column align-items-start position-relative mb-4"
			onClick={props.onClick}
			style={{
				cursor: 'pointer',
				border: '1px solid #ddd',
				borderRadius: '12px',
				padding: '20px',
				background: '#fff',
			}}
		>
			<div className="d-flex flex-row justify-content-between align-items-start w-100 mb-2">
				<img src={imgSrc} alt={props.entityKey + ' icon'} />
			</div>
			<div className="d-flex flex-row justify-content-between align-items-center w-100 mb-2">
				<p
					className="mb-0 text-start"
					style={{ fontSize: props?.customDetails?.fontSize }}
				>
					{props.entityKey.toUpperCase() + ' WISE'}
				</p>
				<img src={RightArrow} alt="arrow" style={{ marginLeft: 8 }} />
			</div>
			<div className="text-start w-100">
				<p
					className="mb-0"
					style={{
						fontSize: props?.customDetails?.fontSize,
						color: props?.customDetails.textColor,
					}}
				>
					{text.entityText[props.entityKey]}
				</p>
			</div>
		</div>
	);
};

export default Entity;
